/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="securityRolesManager.module.ts" />


module Meevo.Plugins.SecurityRolesManager {
  class SecurityRolesManagerController {

    closeContext: Function;
    context: SecurityRolesManagerContext;

    static $inject = [
      "meevo.AppSettings",
      "meevo.components.common.IdentityService",
      "meevo.components.common.DataService",
      "meevo.components.modal.ModalService",
      "meevo.components.tracking.TrackingService",
      "$rootScope",
      "meevo.components.busy.BusyService",
        "$state"
    ];

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected dataService: Meevo.Components.BaseClasses.IDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected trackingService: Meevo.Components.Tracking.ITrackingService,
      protected $rootScope: angular.IRootScopeService,
      protected busyService: Meevo.Components.Busy.IBusyService,
      protected $state: any) {

      let vm = this;
      vm.context = new SecurityRolesManagerContext(appSettings, identityService, dataService, modalService, busyService, trackingService);

      vm.closeContext = (): void => {
        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
      }
    }
  }

  angular.module("meevo.plugins.securityRolesManager")
    .controller("meevo.plugins.securityRolesManager.SecurityRolesManagerController", SecurityRolesManagerController);
}